import useAPI from '@/hooks/useAPI';
import AddressRepository from '@/repositories/AddressRepository';

export const useUsStates = (enabled = true) => {
  const addressRepository = AddressRepository();

  return useAPI({
    queryKey: ['usStates'],
    queryFn: async () => {
      return await addressRepository.getUsStatesList();
    },
    enabled
  });
};

export default useUsStates;
